<template>
  <div class="custom-select">
    <select
      class="form-control"
      :name="name"
      :class="{
        'cl-tertiary' : options.length === 0,
        'empty': !selected
      }"
      :autocomplete="autocomplete"
      @focus="$emit('focus')"
      @blur="$emit('blur')"
      @change="$emit('change', $event.target.value)"
      @input="$emit('input', $event.target.value)"
    >
      <option selected disabled value>
        Wybierz opcję
      </option>
      <option
        v-for="opval in options"
        :key="opval"
        :value="opval"
      >
        {{ opval }}
      </option>
    </select>
    <label :for="name + 'subscription-select'" class="visually-hidden">{{ name }}</label>
    <ValidationMessages v-if="validations" :validations="validations" />
  </div>
</template>

<script>
import ValidationMessages from './ValidationMessages.vue'

export default {
  name: 'SubscriptionSelect',
  components: {
    ValidationMessages
  },
  props: {
    id: {
      type: String,
      required: false,
      default: ''
    },
    name: {
      type: String,
      required: false,
      default: ''
    },
    options: {
      type: Array,
      required: true,
      default: () => []
    },
    selected: {
      type: String,
      required: false,
      default: ''
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    autocomplete: {
      type: String,
      required: false,
      default: ''
    },
    validations: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
@import '~theme/css/base/text';
$color-main: color(main);

.custom-select {
  &::after {
    content: '';
    border: solid $color-main;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 4px;
    transform: rotate(45deg);
    display: block;
    position: absolute;
    top: 20px;
    right: 20px;
    width: 0;
    height: 0;
    pointer-events: none;
  }
  position: relative;
  select {
    font: inherit;
    z-index: 2;
    text-transform: none;
    outline: none;
    &:focus {
      background:#F7F7F7;
      color: #000;
      border-width: 2px;
      border-color: #F7F7F7;
    }
    &:disabled,
    &:disabled + label {
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
    }
  }
  .form-control {
    display: block;
    font-size: 14px;
    color: #000;
    background: #F7F7F7;
    border: 2px solid #F7F7F7;
    border-radius: 30px;
    box-shadow: none;
    padding: 7px 25px 7px 25px;
    margin: 0px;
    width: 100%;
    box-sizing: border-box;
    line-height: 1.5;
    -webkit-appearance: none;
    -moz-appearance: none;
    min-height: 44px;
    transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease, border-radius 0.2s ease;
    option {
      font-size: 17px;
    }
  }
}
</style>
